import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AppSetting } from '../../../global/appsetting';
import { LoaderService } from '../../../services/loader.service';
import { EmailServiceService, Mail } from '../../../services/email-service.service';
import { GaAnalyticsService, EVENT_TYPES } from 'src/app/services/ga-analytics.service';

@Component({
  selector: 'app-arch-escort',
  templateUrl: './arch-escort.component.html',
  styleUrls: ['./arch-escort.component.scss']
})
export class ArchEscortComponent implements OnInit {
  isFormActivate = false;
  isFirstLoad = true;
  name = '';
  email = '';
  emailCopy = '';
  phone = '';
  content = '';
  displaySucceedMsg = false;
  displayFailddMsg = false;
  fieldHasError = [false, false, false, false];
  recaptchaKey: string;
  captchaResponse = '';
  enableClick = true;
  displayAboutAsOrigin = false;
  displayGoogleRobot = true;
  @Output() toggelEscourt = new EventEmitter();
  constructor(public emailService: EmailServiceService,
    public loaderService: LoaderService,
    public appsetting: AppSetting, 
    private gaAnalyticsService: GaAnalyticsService) {
    this.recaptchaKey = this.appsetting.reCaptchaKey;
  }


  ngOnInit() {
  }
  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }
  resetFields() {
    this.name = '';
    this.email = '';
    this.phone = '';
    this.content = '';
    this.displayGoogleRobot = false;
    setTimeout(() => {
      this.displayGoogleRobot = true;
    }, 500);
    //grecaptcha.reset();
  }
  validateForm() {
    let res = true;
    this.fieldHasError = [false, false, false];
    if (this.name === '') {
      this.fieldHasError[0] = true;
      res = false;
    }
    if (this.email === '') {
      this.fieldHasError[1] = true;
      res = false;
    }
    if (this.email !== this.emailCopy) {
      this.fieldHasError[3] = true;
      res = false;
    }
    if (this.captchaResponse === '') {
      this.fieldHasError[2] = true;
      res = false;
    }
    return res;
  }
  validateSpacificField(event, index) {
    if (event.target.classList.contains('ng-dirty')) {
      if (event.target.value === '') {
        this.fieldHasError[index] = true;
      } else {
        this.fieldHasError[index] = false;
      }
    }
  }
  sendMail() {

    if (this.validateForm() || this.captchaResponse !== '') {
      let body = '<div style="direction: rtl"><b>המייל נשלח אליך מ</b>: ' + this.name;
      body += '<br /><b>כתובת</b>: ' + this.email;
      body += '<br /><b>טלפון</b>' + this.phone;
      body += '<br /> <b>פירוט הבקשה</b>: ליווי אדריכלי צמוד';
      const mail: Mail = { userEmail: this.email, body: body, mailType: 3, fileList: null, captchaResponse: this.captchaResponse };
      this.loaderService.displayLoader(false);
      this.displayFailddMsg = false;
      this.displaySucceedMsg = false;
      this.emailService.sendMail(mail).subscribe(
        (res: boolean) => {
          this.loaderService.hideLoader();
          if (res) {
            this.resetFields();
            this.displaySucceedMsg = true;
          } else {
            this.displayFailddMsg = true;
          }
          this.displayGoogleRobot = false;
          window.setTimeout(() => {
            this.displayGoogleRobot = true;
          }, 1000);
        }, error => {
          this.gaAnalyticsService.logEventToGa('sendMail', 'ArchEscortComponent', EVENT_TYPES.Error);
          this.loaderService.hideLoader();
          this.displayFailddMsg = true;
          this.displayGoogleRobot = false;
          window.setTimeout(() => {
            this.displayGoogleRobot = true;
          }, 1000);
          console.log('could not send email');
        });
    }


  }
  close() {
    this.toggelEscourt.emit();
  }
}
